export const getScoreValue = (TABLE_CONSTANTS, scoreKey, columnIndex) => {
  const scoreValue = TABLE_CONSTANTS[scoreKey];
  if (scoreValue !== undefined) {
    return typeof scoreValue === 'object' && scoreValue !== null ?
        scoreValue[columnIndex] ?? NaN :
        scoreValue;
  }
  return NaN;
};

export const getDefaultValue = (TABLE_CONSTANTS, columnIndex) => {
  if (TABLE_CONSTANTS.CUSTOM_EMPTY_FIELDS) {
    const columnInfo = TABLE_CONSTANTS.CUSTOM_EMPTY_FIELDS.find((field) => field.COLUMN_INDEX === columnIndex);
    if (columnInfo) {
      return columnInfo.DEFAULT_VALUE;
    }
  }
  return '--';
};
